module.exports = __webpack_public_path__ + "static/media/error-logo.637c3e17.svg";